<!-- <app-pro-partner-show-header></app-pro-partner-show-header>
<app-pro-partner-show-content></app-pro-partner-show-content> -->

<!-- consolodating these components into one for ease of use -->

<div class="container">
    <div class="left-section">
        <button id="all-shows-btn" type="button" class="action-button"
            [class.action-button--active]="selectedPartnerGroupId === null"
            [attr.aria-pressed]="selectedPartnerGroupId === null" (click)="selectedPartnerGroupId = null"> All Shows
        </button>
        <div class="partner-group-buttons">
            <div *ngFor="let group of partnerGroupsBtnDisplay; trackBy: trackById">
                <button #tooltipButton type="button" class="partner-group-button action-button"
                    matTooltip="{{group.name}}" [class.action-button--active]="selectedPartnerGroupId === group.id"
                    [attr.aria-pressed]="selectedPartnerGroupId === group.id"
                    (click)="selectedPartnerGroupId = group.id">
                    <span class="group-name">{{group.name}}</span>
                    <app-information-icon
                        (click)="showPartnerGroupToolTip($event, tooltipButton, group.id)"></app-information-icon>
                </button>
            </div>
        </div>
    </div>
</div>

<form class="search-filter" [ngClass]="{'search-filter-focused': searchFilterFocused}" #searchForm="ngForm">
    <label for="search-filter-field" class="icon">
        <svg *ngIf="!searchFilterFocused" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
            <path fill="none" stroke="#15151c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20"
                d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535" />
        </svg>
        <svg *ngIf="searchFilterFocused" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
            <path fill="none" stroke="#15151c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20"
                d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535" />
        </svg>
    </label>
    <input name="searchString" type="text" class="txt" id="search-filter-field"
        placeholder="{{searchFilterFocused ? 'Search shows' : 'Search'}}" (focus)="searchFilterFocused = true"
        (input)="getSearchVal($event.target.value)">
    <input type="reset" value="Cancel" class="btn-reset" (click)="searchFilterFocused = false;searchString = ''">
    <input type="submit" value="Search" class="btn-submit" (click)="filterData(searchString)">
    <!-- <mat-select class="search-category-select" [(ngModel)]="searchCategory" (ngModelChange)="unassignMapping(i)"> -->
    <!-- <mat-select class="search-category-select" [(ngModel)]="searchCategory">
                <mat-option disabled>Select a Partner Group</mat-option>
                <mat-option *ngFor="let group of partnerGroups;" [value]="group">{{group.name}}</mat-option>
            </mat-select> -->
</form>

<div class="table-container">
    <mat-table matSort multiTemplateDataRows [dataSource]="dataSource" background="#15151c" class="show-table">

        <ng-container matColumnDef="show">
            <mat-header-cell *matHeaderCellDef mat-sort-header> SHOW <app-sort-arrows-icon></app-sort-arrows-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="show-name"> {{element.title}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="seasons">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered-cell"> SEASONS
                <app-sort-arrows-icon></app-sort-arrows-icon></mat-header-cell>
            <mat-cell *matCellDef="let element" class="centered-cell"> {{getSeasonsCount(element)}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="partnerGroup">
            <mat-header-cell *matHeaderCellDef mat-sort-header> PARTNER GROUP
                <app-sort-arrows-icon></app-sort-arrows-icon></mat-header-cell>
            <mat-cell *matCellDef="let element" class="partner-group-cell">
                {{getPartnerGroupName(element.partnerGroup_id)}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row" class="action-cell">
                <div class="actions-buttons">
                    <button type="button" matTooltip="Move to partner group" matTooltipClass="tooltip-white"
                        aria-label="Move to partner group" (click)="moveShow(row)">
                        <app-move-arrow-icon></app-move-arrow-icon>
                    </button>

                    <button>
                        <app-drop-down-arrow *ngIf="!row.expandDetails" (click)="toggleDetails(row)"
                            [stroke]="'#50e3c2'"></app-drop-down-arrow>
                        <app-drop-down-arrow *ngIf="row.expandDetails" (click)="toggleDetails(row)" [stroke]="'#50e3c2'"
                            [pointUp]="true"></app-drop-down-arrow>
                    </button>
                </div>
            </mat-cell>
        </ng-container>


        <!-- Expanded details row -->

        <ng-container matColumnDef="expandedDetails">
            <mat-cell [attr.colspan]="displayedColumns.length + 1" *matCellDef="let element">

                <div class="season-table">
                    <div *ngFor="let season of element.seasons; trackBy: trackById" class="season-row">
                        <div class="season-details-tab">
                            <div class="season-name">
                                Season {{season.season_number}}
                            </div>
                            <!-- <div class="season-air-dates">
                                {{season.airDateStart | date: 'MMM d yyyy'}} - {{season.airDateEnd | date: 'MMM d yyyy'}}
                            </div> -->
                            <app-drop-down-arrow *ngIf="!season.expandDetails" [stroke]="'#50e3c2'"
                                (click)="toggleDetails(season)"></app-drop-down-arrow>
                            <app-drop-down-arrow *ngIf="season.expandDetails" [stroke]="'#50e3c2'" [pointUp]="true"
                                (click)="toggleDetails(season)"></app-drop-down-arrow>
                        </div>

                        <div *ngIf="season.expandDetails" class="episodes">
                            <div *ngFor="let episode of season.episodes; trackBy: trackById" class="episode-row">
                                <div class="episode-name-display">
                                    <span>S{{season.season_number}} E{{episode.episode_number}} -
                                        {{episode.title}}</span>
                                </div>
                                <div class="episode-partner-group"
                                    [class.episode-partner-group--inherited]="!episodeHasOwnPartnerGroup(episode)"
                                    [matTooltip]="episodeHasOwnPartnerGroup(episode) ? '' : 'Same as the show'"
                                    matTooltipClass="tooltip-white">
                                    {{episodePartnerGroupName(element, episode)}}
                                </div>
                            </div>
                            <!-- the API lists only the episodes that pay this partner, so a season can be empty -->
                            <div *ngIf="!season.episodes.length" class="episode-row no-episodes">
                                <div class="episode-name-display">No episodes for this partner</div>
                            </div>
                        </div>

                    </div>
                </div>

            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"
            [ngClass]="{'show-row-expanded':styleExpandedDetailsRow(row), 'show-row': !styleExpandedDetailsRow(row)}"></mat-row>

        <!-- Expanded details row definition -->
        <mat-row *matRowDef="let row; columns: ['expandedDetails'];"
            [ngClass]="{'details-expanded':styleExpandedDetailsRow(row), 'details-hidden': !styleExpandedDetailsRow(row)}"></mat-row>
    </mat-table>
</div>